import {
  CREATE_ITEM_LOT_RATE,
  DELETE_ITEM_LOT_RATE,
  GET_ITEM_LOT_RATE,
  GET_ITEM_LOT_RATE_PAGE,
  ITEM_LOT_RATE_REQUEST,
  ITEM_LOT_RATE_REQUEST_FAILURE,
  ITEM_LOT_RATE_REQUEST_SUCCESS,
  UPDATE_ITEM_LOT_RATE
} from "../types/item-lot-rate-types";

const initialState = {
  itemLotRate: [],
  itemLotRatePage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const itemLotRateReducer = (state = initialState, action) => {
  switch (action.type) {
    case ITEM_LOT_RATE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_ITEM_LOT_RATE: {
      return {
        ...state,
        itemLotRate: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_ITEM_LOT_RATE_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        itemLotRatePage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_ITEM_LOT_RATE: {
      return {
        ...state,
        itemLotRate: [action.payload, ...state.itemLotRate],
        loading: false,
        error: null
      };
    }
    case UPDATE_ITEM_LOT_RATE: {
      const itemLotRateData = state.itemLotRate.slice(0);
      const uIndex = itemLotRateData.findIndex((data) => data.id === action.payload.id);
      itemLotRateData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        itemLotRate: [ ...itemLotRateData ],
        loading: false,
        error: null
      };
    }
    case DELETE_ITEM_LOT_RATE: {
      const itemLotRate = state.itemLotRate?.slice(0);
      const index = itemLotRate.findIndex((data) => data.id === action.id);
      if (index > -1) {
        itemLotRate.splice(index, 1);
      }
      return {
        ...state,
        itemLotRate: [...itemLotRate],
        loading: false,
        error: null
      }
    }
    case ITEM_LOT_RATE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case ITEM_LOT_RATE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default itemLotRateReducer;
